import React from 'react'

export default function Join() {
    return (
        <div className='md:p-0 p-5'>
            <a href="#">
                <img src="/images/join.png" alt="" className='hover:!scale-100 animate__fadeInUp wow animate__animated md:block hidden' />
                <img src="/images/join-mobile.png" alt="" className='hover:!scale-100 animate__fadeInUp wow animate__animated md:hidden block' />

            </a>
        </div>
    )
}
